import { Box } from "@material-ui/core";
import { Grid, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../App.css";
import { ReactComponent as InvitationIconWhite } from "../../assets/DashBoardTableIcons/InvitationIconWhite.svg";
import { ReactComponent as SelfRegistration } from "../../assets/DashBoardTableIcons/SelfRegistration.svg";
import { ReactComponent as WalkInRegistrationIcon } from "../../assets/DashBoardTableIcons/RegistrationIconWalkIn.svg";
import { ReactComponent as PreRegistration } from "../../assets/DashBoardTableIcons/PreRegistration.svg";
const CustomStyles = (props) => {
  const { t } = useTranslation();
  const [icon, setIcon] = useState(props.icon);

  const iconContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "15px",
  };

  const StatusTab = (props) => {
    return (
      <>
        <Box
          style={{
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Grid style={{ flex: "0 0 150px" }}>
            <Typography style={{ padding: "4px" }}>
              {" "}
              {t(props.status)}
            </Typography>
          </Grid>
          <Grid>{props.Icon}</Grid>
        </Box>
      </>
    );
  };

  // "PENDING_ARRIVAL" -> "Pending Arrival"
  const formatStatusLabel = (status) => {
    if (typeof status !== "string" || status === "") return "";
    return status
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  function SwitchCase(props) {
    switch (props.row.row) {
      case "SCHEDULED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#EDBD37",
                backgroundColor: "#EDBD3726",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS011")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "RESCHEDULED":
        return (
          <span
            style={{
              color: "#EDBD37",
              backgroundColor: "#EDBD3726",
              opacity: 1,
              borderRadius: "7px",
            }}
          >
            <StatusTab status={t("RESCHEDULED")} />
          </span>
          //   </Grid>
        );

      case "COMPLETED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#008000",
                backgroundColor: "#ccffcc",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS020")} />
            </span>
          </Grid>
        );

      case "PENDING_ARRIVAL":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#E16B05",
                backgroundColor: "#E16B0526",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("Pending Arrival")} />
            </span>
          </Grid>
        );

      case "EXPIRED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#E3393C",
                backgroundColor: "#E3393C1A",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab
                status={t("EXPIRED")}
                style={{ width: "100% !important" }}
              />
            </span>
          </Grid>
        );

      case "LOGGED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#008000",
                backgroundColor: "#ccffcc",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS021")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "APPROVED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#36C96D",
                backgroundColor: "#36C96D26",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS015")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "CONFIRMED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#A6C212",
                backgroundColor: "#A6C21226",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS012")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "CHECKED_OUT":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#03ACBF",
                backgroundColor: "#03ACBF26",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS018")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "PRE_REGISTRATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "PRE_REGISTRATION"
                        ? "Pre Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <PreRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "CANCELLED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#E3393C",
                backgroundColor: "#E3393C26",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS013")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "PRE_REGISTRATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "PRE_REGISTRATION"
                        ? "Pre Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <PreRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "Rescheduled":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#EDBD37",
                backgroundColor: "#EDBD3726",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={"Rescheduled"} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "CHECKED_IN":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#287ADC",
                backgroundColor: "#287ADC26",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS017")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "PRE_REGISTRATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "PRE_REGISTRATION"
                        ? "Pre Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <PreRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "INITIATED_FOR_BLOCKED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#D53033",
                backgroundColor: "#D5303326",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab
                status={
                  process.env.REACT_APP_ENVIRONMENT === "USA"
                    ? "Blocklist Initiated"
                    : "Block Initiated"
                }
              />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "BLOCKED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#D53033",
                backgroundColor: "#D5303326",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab
                status={
                  process.env.REACT_APP_ENVIRONMENT === "USA"
                    ? t("VISSTATUS019")
                    : "Blocked"
                }
              />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "PRE_REGISTRATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "PRE_REGISTRATION"
                        ? "Pre Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <PreRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "REJECTED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#E3393C",
                backgroundColor: "#E3393C26",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS014")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
            {props.row.visitMode === "PRE_REGISTRATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "PRE_REGISTRATION"
                        ? "Pre Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <PreRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      case "MISSED":
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#ED8637",
                backgroundColor: "#ED863726",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t("VISSTATUS016")} />
            </span>

            {props.row.visitMode === "INVITATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "INVITATION" ? "Invitation" : ""
                    }
                  >
                    {/* <CancelledIcon /> */}
                    <InvitationIconWhite
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "SELF_REGISTARTION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "SELF_REGISTARTION"
                        ? "Self Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <SelfRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "WALKIN_REGISTARTION_KIOSK" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "WALKIN_REGISTARTION_KIOSK"
                        ? "Walk-In Registration"
                        : ""
                    }
                  >
                    {/* <RegistrationIcon /> */}
                    <WalkInRegistrationIcon
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}

            {props.row.visitMode === "PRE_REGISTRATION" ? (
              <span style={iconContainerStyle}>
                {icon ? (
                  <Tooltip
                    title={
                      props.row.visitMode === "PRE_REGISTRATION"
                        ? "Pre Registration"
                        : ""
                    }
                  >
                    {/* <ApprovedIcon /> */}
                    <PreRegistration
                      style={{ fill: props?.darkMode ? "#fff" : "#474a4e" }}
                    />
                  </Tooltip>
                ) : null}
              </span>
            ) : null}
          </Grid>
        );

      default:
        // props.row is the props object, so render the status string, never the object itself
        // (rendering an object crashes the whole app, e.g. for PENDING_ARRIVAL events)
        return (
          <Grid display={"flex"}>
            <span
              style={{
                color: "#6B7280",
                backgroundColor: "#6B728026",
                opacity: 1,
                borderRadius: "7px",
              }}
            >
              <StatusTab status={t(formatStatusLabel(props.row.row))} />
            </span>
          </Grid>
        );
    }
  }

  return <div>{<SwitchCase row={props} />}</div>;
};

export default CustomStyles;
